import styled from "styled-components";

export const StyledTitle = styled.p`
  font-weight: 500;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  line-height: 21px;
  color: #264445;

  max-width: 95%;
  @media (max-width: 425px) {
    font-size: 16px;
  }
`;

export const StyledIcon = styled.div`
  transition: all ease 0.5s;
  svg {
    width: 17px;
    height: 17px;
  }
  svg use {
    fill: #bfc4ca;
  }
`;

export const StyledDescription = styled.p`
  color: #37373a;
  padding-bottom: 12px;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 24px;

  a {
    color: inherit;
  }
  @media (max-width: 425px) {
    font-size: 14px;
  }
`;

export const StyledContainer = styled.div`
  border-radius: 3px;
  border: solid 1px #dddee0;
  width: 100%;
  height: auto;
  padding: 31px 38px 30px 33px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr auto;
  background-color: #f7f8fa;
  cursor: pointer;
  grid-row-gap: 16px;
  align-items: center;
  transition: 0.25s all ease;
  &:hover {
    border-color: #0068FF;
  }
  &:hover ${StyledTitle} {
    color: #0068FF;
  }
  &:hover ${StyledIcon} {
    svg use {
      fill: #0068FF;
    }
  }
`;
